module.exports = {
  ANYW: "ANYW",
  CARD: "CARD",
  CBOT: "CBOT",
  CCFD: "CCFD",
  CCTK: "CCTK", // customer collections
  CEMS: "CEMS",
  CEXP: "CEXP",
  CINS: "CINS",
  CMID: "CMID",
  COHD: "COHD",
  CONT: "CONT",
  COVD: "COVD",
  CRET: "CRET",
  CRFI: "CRFI",
  CRTK: "CRTK",
  CTWD: "CTWD",
  CUSR: "CUSR",
  CUST: "CUST",
  DASH: "DASH",
  DCFI: "DCFI",
  DCMP: "DCMP",
  DDIA: "DDIA",
  DDVL: "DDVL",
  DHAI: "DHAI",
  DHDP: "DHDP",
  DICH: "DICH",
  DICL: "DICL",
  DICP: "DICP",
  DIDP: "DIDP",
  DILD: "DILD",
  DILL: "DILL",
  DINS: "DINS",
  DIPO: "DIPO",
  DIPR: "DIPR",
  DOND: "DOND",
  DONF: "DONF",
  DONR: "DONR",
  DOOD: "DOOD",
  DOOF: "DOOF",
  DPDD: "DPDD",
  DPDH: "DPDH",
  DPDS: "DPDS",
  DPER: "DPER",
  DPLS: "DPLS",
  DPPA: "DPPA",
  DPPC: "DPPC",
  DPPK: "DPPK",
  DPPP: "DPPP",
  DPPR: "DPPR",
  DRCV: "DRCV",
  DRFI: "DRFI",
  DSAC: "DSAC",
  DSAH: "DSAH",
  DSIG: "DSIG",
  DSNT: "DSNT",
  DSRC: "DSRC",
  DUAL: "DUAL",
  DUNA: "DUNA",
  DUNN: "DUNN",
  DUTL: "DUTL",
  DUTY: "DUTY",
  EBCH: "EBCH",
  IAD: "IAD",
  INLD: "INLD",
  NOTE: "NOTE", // fmp user went from sms short url
  NOTR: "NOTR",
  NOTS: "NOTS",
  NTHM: "NTHM",
  PATK: "PATK",
  PCTK: "PCTK",
  PDTK: "PDTK",
  PRCU: "PRCU",
  PRTI: "PRTI",
  PRTK: "PRTK",
  PTUK: "PTUK",
  RECN: "RECN",
  RODH: "RODH",
  ROUT: "ROUT",
  RPRF: "RPRF",
  SONE: "SONE",
  TRHD: "TRHD",
  VIEW: "VIEW",
  YOUR: "YOUR", // your dpd
};
